<template>
  <div>
    <!--    引入头部组件-->
    <nav-header></nav-header>
    <div id="v-content" :style="{minHeight: height+'px'}"><router-view /></div>
    <!--    引入底部组件-->
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import NavHeader from '../components/NavHeader'
import NavFooter from '../components/NavFooter'
export default {
  name: 'home',
  components: { NavFooter, NavHeader },
  data () {
    return {
      height: 0
    }
  },
  mounted () {
    // 动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.height = document.documentElement.clientHeight
    // 监听浏览器窗口变化
    window.onresize = () => { this.height = document.documentElement.clientHeight }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home.vue